import styled from "styled-components";

export const AttachmentListItemsDiv = styled.div`
    margin: 0 0 16px 0;
`;

export const AttachmentListItemsUL = styled.ul`
    padding-left: 0;
    margin-top: 0;
    max-height: 200px;
    overflow-x: hidden;
`;
